module.exports = __webpack_public_path__ + "img/pic_xifashui1.94dfb28a.png";